import { I18nContext } from '@bingads-webui-react/i18n-context';
import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import { ThirdPartyMeasurementCardContainer } from './third-party-measurement-container';


const overrideStyles = {
  thirdPartyMeasurementFolderButton: {
    label: { color: '#0078D4', fontWeight: 600 },
    icon: {
      fontSize: 14, fontWeight: 600, marginLeft: 0, marginRight: 4,
    },
    root: { verticalAlign: 'middle' },
  },
  disconnectedStatusTile: {
    root: {
      marginLeft: 0,
    },
  },
  connectedStatusTile: {
    root: {
      marginLeft: 0,
    },
  },
};

export class ThirdPartyMeasurementBackboneView extends Backbone.View {
  initialize({
    i18n,
    initialThirdPartyMeasurement,
    isMOATEnabled = false,
  }) {
    this.i18n = i18n;
    this.validationProps = {
      data: {
        VerifiedTrackingSettings: initialThirdPartyMeasurement,
      },
    };
    this.isMOATEnabled = isMOATEnabled;
    this.saveVerifiedTrackingSetting = this.saveVerifiedTrackingSetting.bind(this);
    return this;
  }

  // We need to make this func fit for ThirdPartyMeasurementCardContainer
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  saveVerifiedTrackingSetting(dummyErrorArr = [], VerifiedTrackingObj) {
    const verifiedTrackingSettings = VerifiedTrackingObj.VerifiedTrackingSettings;

    this.trigger('InputChange', verifiedTrackingSettings);
  }

  renderWithInput(verifiedTrackingObj) {
    this.validationProps = {
      data: {
        VerifiedTrackingSettings: verifiedTrackingObj,
      },
    };
    this.render();
  }

  render() {
    ReactDOM.render(
      <I18nContext.Provider value={this.i18n}>
        <ThirdPartyMeasurementCardContainer
          i18n={this.i18n}
          validationProps={this.validationProps}
          updateValidation={this.saveVerifiedTrackingSetting}
          adType="native"
          overrideStyles={overrideStyles}
          isMOATEnabled={this.isMOATEnabled}
          showSimpleMessage
        />
      </I18nContext.Provider>
      , this.el
    );
    return this;
  }
}

